import type { FormDataOf } from '../../../../../types/templates';
import { ESPNVSPlayerVSPlayerConfig } from '../../../../../types/banner/clients/DISNEY/creativity-configs';
import { disneyEspnPlayerVSPlayer } from '..';

type FormData = FormDataOf<typeof disneyEspnPlayerVSPlayer>;

export const cleanFormData = (formData: FormData): ESPNVSPlayerVSPlayerConfig => {
  const { league, team1, player1, team2, player2 } = formData;
  return { league, team1, player1, team2, player2 };
};
